import React, { useEffect, useState } from 'react';
import { useAuth } from "../../context/AuthContext";
import { UserContext } from "../../context/UserContext";
import { useLocation } from "react-router-dom";

import ProfileNavigateLayout from './ProfileNavigateLayout';
import './UserAppointments.css';
// import img from '../../../images/avatar.jpg';

// import './Appointments.css';
// import { useGetDoctorAppointmentsQuery, useUpdateAppointmentMutation } from '../../../redux/api/appointmentApi';
import moment from 'moment';
import { Button, Empty, message, Tag, Tooltip } from 'antd';
import { FaEye, FaCheck, FaTimes } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { FaClock, FaLocationArrow, FaPhoneAlt, FaBriefcase, FaEnvelope, FaGoogle, FaDollarSign, FaUser, FaCheckCircle, FaHourglassHalf, FaTimesCircle } from "react-icons/fa";
import {GiBrain} from "react-icons/gi";
// import { clickToCopyClipBoard } from '../../../utils/copyClipBoard';

const UserAppointments = () => {

    const {user} = useAuth(UserContext);
    const [userDoctor, setUserDoctor] = useState(null)

    const location = useLocation();
    // const { appointments } = UserAppointments();
    // const appointments = location.state?.appointments || [];
    const appointments = (location.state?.appointments || []).sort((a, b) => {
        return new Date(a.dateTime) - new Date(b.dateTime);
    });
    
    // const [updateAppointment, { isError: updateIsError, isSuccess, error }] = useUpdateAppointmentMutation();

    

    // fetchAppointments();


    // const updatedApppointmentStatus = (id, type) => {
    //     const changeObj = {
    //         status: type
    //     }
    //     if (id) {
    //         updateAppointment({ id, data: changeObj })
    //     }
    // }

    // useEffect(() => {
    //     if (isSuccess) {
    //         message.success("Succcessfully Appointment Updated")
    //     }
    //     if (isError) {
    //         message.error(error?.data?.message);
    //     }
    // }, [isSuccess, updateIsError, error])

    // const getInitPatientName = () => {
    //     const fullName = `${data?.patient?.firstName ?? ''} ${data?.patient?.lastName ?? ''}`;
    //     return fullName.trim() || "Private Patient";
    // }

    function formatAddress(city, zipCode, street, addressNo1, addressNo2, state, country) {
        if (!city) return "BRAK PODANEGO ADRESU!";

        const line1 = `ul. ${street || ""} ${addressNo1 || ""}${addressNo2 ? "/" + addressNo2 : ""}`.trim();
        const line2Parts = [zipCode, city].filter(Boolean).join(" ");
        const line3Parts = [state, country].filter(Boolean).join(", ")

        // Return JSX directly with <br />
        return (
            <>
                {line1}<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{line2Parts} <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{line3Parts}
            </>
        );
    }

    const selectCurrentOrArchive = (item, field) => {
        return item?.user?.[field] ?? item?.archivedUser?.[field];
    }
    
    const getFullName = (firstName, lastName) => {
        const fullName = `${firstName ?? ''} ${lastName ?? ''}`;
        return fullName.trim() || "Private Patient";
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}.${month}.${year}, ${hours}:${minutes}`; // Return the formatted date
    };

    const currentDateTime = new Date();
    const parseDateTime = (dateString) => new Date(dateString);

    // let content = null;
    const content =
        <>
        <h3 className="appointments-header">Twoje Wizyty</h3>
            {
            appointments && appointments.map((item) => (
                <div className="w-100 mb-3 rounded p-3 item-tab" style={{ background: '#f8f9fa' }} key={item.id}>
                    <div className="row">
                        <h5 style={{ marginBottom: "2rem"}}><FaUser className='icon' />{" "}
                                        Pacjent: <span style={{fontWeight: 600}}>
                                                    {getFullName(item.patientFirstName, item.patientLastName)}
                                                </span>
                        </h5>
                        {/* <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-3"> */}
                        <div className="col-md-4 mb-3">

                            <div className="info mt-2">
                                <p><FaEnvelope className='icon' /> {" "}
                                    <span style={{ fontWeight: 500 }}>Email:{" "}</span> <span style={{ fontWeight: 600 }}>{item.patientEmail}</span>
                                </p>
                                <p><FaPhoneAlt className='icon' /> 
                                    <span style={{ fontWeight: 500 }}>Telefon:{" "}</span> <span style={{ fontWeight: 600 }}>{item.patientPhoneNumber}</span>
                                </p>
                                <p><FaLocationArrow className='icon' /> {" "}<span style={{ fontWeight: 500 }}>Adres:{" "}</span>
                                    <span style={{ fontWeight: 600 }}>
                                        {formatAddress(
                                            item.address.city, 
                                            item.address.zipCode, 
                                            item.address.street, 
                                            item.address.addressNo1, 
                                            item.address.addressNo2, 
                                            item.address.state, 
                                            item.address.country)}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="info mt-2">
                                <p><FaClock className='icon' /> {" "}
                                    <span style={{ fontWeight: 500 }}>Data:{" "}</span> <span style={{ fontWeight: 600 }}>{formatDate(item?.dateTime)}</span>
                                </p>
                                <p><GiBrain className='icon' /> {" "}
                                    <span style={{ fontWeight: 500 }}>Usługa:{" "}</span> <span style={{ fontWeight: 600 }}>{item?.disorder?.serviceName}</span>
                                </p>
                                <p><FaBriefcase className='icon' /> {" "}
                                    <span style={{ fontWeight: 500 }}>Diagnosta:{" "}</span> 
                                    <span style={{ fontWeight: 600 }}>{getFullName(item?.doctor?.firstName, item?.doctor?.lastName)}</span>
                                </p>
                                <p><FaDollarSign className='icon' /> {" "}
                                    <span style={{ fontWeight: 500 }}>Cena:{" "}</span> <span style={{ fontWeight: 600 }}>{item?.disorder?.pricePln} zł</span>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="info mt-2">
                                <p><FaGoogle className='icon' /> {" "}
                                    <span style={{ fontWeight: 500 }}>Link:{" "}</span> <span style={{ fontWeight: 600 }}>{item?.link}</span></p>
                                <p>
                                {item?.status === 'AWAITING_PAYMENT' ? (
                                    <><FaHourglassHalf color="orange" /> {" "}
                                        <span style={{ fontWeight: 500 }}>Status:</span> {" "}
                                        <span style={{ fontWeight: 600 }}>Wizyta Nieopłacona</span>
                                    </>
                                ) : item?.status === 'IS_PAID' ? (
                                    <><FaCheckCircle color="green" /> {" "}
                                        <span style={{ fontWeight: 500 }}>Status:</span> {" "}
                                        <span style={{ fontWeight: 600 }}>Wizyta Opłacona</span>
                                    </>
                                ) : item?.status === 'FINISHED_SUCCESSFULLY' ? (
                                    <><FaCheckCircle color="green" /> {" "}
                                        <span style={{ fontWeight: 500 }}>Status:</span> {" "}
                                        <span style={{ fontWeight: 600 }}>Wizyta się odbyła</span>
                                    </>
                                ) : (
                                    <><FaTimesCircle color="red" /> {" "}
                                        <span style={{ fontWeight: 500 }}>Status:</span> {" "}
                                        <span style={{ fontWeight: 600 }}>Wizyta anulowana</span>
                                    </>
                                )}
                                </p>
                            </div>
                        </div>
                    
                    {item?.user?.role === 'USER' && (
                        <div className="bottom-right-actions">
                            <Link
                            to={currentDateTime < parseDateTime(item?.dateTime) ? `/twoje-wizyty/edycja-danych-pacjenta` : '#'}
                            state={{ item }}
                            onClick={(e) => {
                                if (!(currentDateTime < parseDateTime(item?.dateTime))) e.preventDefault();
                            }}
                            >
                                <Button
                                    type="primary"
                                    className={
                                    currentDateTime < parseDateTime(item?.dateTime)
                                        ? 'custom-link-button'
                                        : 'custom-link-button disabled-link-button'
                                    }
                                    disabled={!(currentDateTime < parseDateTime(item?.dateTime))}
                                >
                                    Edytuj swoje dane
                                </Button>
                            </Link>
                            {/* <Link
                            to={currentDateTime > parseDateTime(item?.dateTime) - 24 * 60 * 60 * 1000 ? '#' : `/twoje-wizyty/zmiana-terminu`}
                            state={{ item }}
                            onClick={(e) => {
                                if (currentDateTime > parseDateTime(item?.dateTime) - 24 * 60 * 60 * 1000) e.preventDefault();
                            }}
                            >
                                <Button
                                    type="primary"
                                    className={
                                    currentDateTime <= parseDateTime(item?.dateTime) - 24 * 60 * 60 * 1000
                                        ? 'custom-link-button'
                                        : 'custom-link-button disabled-link-button'
                                    }
                                    disabled={currentDateTime > parseDateTime(item?.dateTime) - 24 * 60 * 60 * 1000}
                                >
                                    Zmień termin wizyty
                                </Button>
                            </Link> */}
                        </div>
                    )}
                </div>
            </div>
            ))
            }
        </>

    return (
        <ProfileNavigateLayout>
            {content}
        </ProfileNavigateLayout>
    )
}

export default UserAppointments